import { render, staticRenderFns } from "./RegistrationReceived.vue?vue&type=template&id=618b5c32&scoped=true&"
import script from "./RegistrationReceived.vue?vue&type=script&lang=js&"
export * from "./RegistrationReceived.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationReceived.vue?vue&type=style&index=0&id=618b5c32&prod&lang=css&"
import style1 from "./RegistrationReceived.vue?vue&type=style&index=1&id=618b5c32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618b5c32",
  null
  
)

export default component.exports